import { api } from "constants/RotasAPI";
import { useGestaoCobrancaCadastroContext } from "context/gestaoCobranca/GestaoCobrancaCadastroContext";
import useFetch from "hooks/useFetch";
import { Page } from "types/dto/Page";
import { RegistroAcordoDTO } from "types/dto/RegistroAcordoDTO";
import { RequestAcordo } from "types/request/RequestAcordos";
import { toast } from "react-hot-toast";

export const useGetAcordosRealizados = (request: RequestAcordo) => {
  const { setAcordos } = useGestaoCobrancaCadastroContext();

  const onSuccess = (response: Page<RegistroAcordoDTO>) => {
    setAcordos(response.content);
  };

  const onError = () => {
    toast.error("Erro ao buscar acordos");
  };

  return useFetch<Page<RegistroAcordoDTO>>({
    key: ["acordos-realizados", request.unidadeId, request.page, request.sort],
    url: api.acordo.getAcordosRealizados,
    params: request,
    enabled: request.unidadeId !== undefined,
    onSuccess,
    onError,
  });
};
